/** 상단 네비·모바일·푸터 사이트맵 공통 (한곳에서만 수정) */

export const AboutMenu = [
    { name: '코담 소개', routerPath: '/about' },
    { name: '핵심 가치', routerPath: '/core-values' },
    { name: '우리가 일하는 방식', routerPath: '/how-we-work' },
    { name: '코담 연혁', routerPath: '/history' },
    { name: '팀 소개', routerPath: '/team' },
    { name: '공지사항', routerPath: '/notices' },
]

/** 코담디자인 확장 메뉴 — 코담디자인 전용 페이지 앵커 */
export const CodamDesignSubmenu = [
    { name: '캐릭터 디자인', routerPath: '/codam-design/character-design' },
    { name: '산업 디자인', routerPath: '/codam-design/industrial-design' },
    { name: '제품 디자인', routerPath: '/codam-design/product-design' },
    { name: '포트폴리오', routerPath: '/codam-design/portfolio' },
]

export const ServiceMenu = [
    { name: '서비스', routerPath: '/services' },
    {
        name: '코담디자인',
        routerPath: '/codam-design',
        children: CodamDesignSubmenu,
    },
    { name: '매출관리 솔루션', routerPath: '/revenue-management' },
    { name: '소프트웨어 개발', routerPath: '/software-development' },
    { name: '구축 사례', routerPath: '/project-grid' },
    { name: '맞춤형 백오피스 시스템', routerPath: '/custom-backoffice' },
    { name: '홈페이지 제작', routerPath: '/website-creation' },
    { name: '이커머스·플랫폼 개발', routerPath: '/ecommerce-platform' },
]

/** 푸터 등 플랫 목록용: 부모 항목 + 하위 항목을 한 줄로 펼침 */
export function flattenServiceMenuForFooter(items = ServiceMenu) {
    return items.flatMap((item) =>
        item.children ? [item, ...item.children] : [item],
    )
}

export const PlatformMenu = [
    { name: '코담체인', routerPath: '/codam-chain' },
    { name: '코담프리페이드카드', routerPath: '/prepaid-card' },
    { name: '코담페이', routerPath: '/codam-pay' },
    { name: '코담톡', routerPath: '/codam-talk' },
    { name: '코담맵', routerPath: '/codam-map' },
]

export const AITechMenu = [
    { name: 'AI 기술', routerPath: '/cyber-security' },
    { name: '코담 AI 코어', routerPath: '/codam-ai-core' },
    { name: '기술 플랫폼', routerPath: '/tech-platform' },
    { name: '개발자 센터', routerPath: '/developer-center' },
    { name: '코담 개발자 서밋', routerPath: '/codam-dev-summit' },
]

export const RecruitMenu = [
    { name: '채용', routerPath: '/recruit' },
    { name: '함께할 크루 모집', routerPath: '/crew-recruit' },
    { name: '채용공고 보기', routerPath: '/job-postings' },
]

export const ESGMenu = [
    { name: 'ESG', routerPath: '/esg' },
    { name: 'ESG 보고서', routerPath: '/esg-report' },
    { name: '소상공인 디지털화', routerPath: '/sme-digitalization' },
    { name: '액티브 그린', routerPath: '/active-green' },
    { name: '디지털 책임', routerPath: '/digital-responsibility' },
]

/** 푸터 전용: 상단 단독 링크「문의하기」와 동일 */
export const FooterContactLink = { name: '문의하기', routerPath: '/contact' }
